export default [
	'pages',
	'static-content',
	'projects',
	'posts'
];
